<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول سمینار ها</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;

                                <a-button href="/seminars/add" class="btn-outline-blue" icon="plus">
                                    افزودن سمینار
                                </a-button>
                               
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-col :md="4" class="mt-3">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>

                            <a-col :md="10">
                                <label class="sr-only" for="inline-form-input-name">
                                    عنوان</label>
                                <b-form-input v-model="search.title" id="inline-form-input-name" class="">
                                </b-form-input>
                            </a-col>

                             <a-col :md="10">
                                <label class="sr-only" for="inline-form-input-name">
                                    مشاهده براساس برگزاری</label>
                                <select class="form-control" v-model="search.date">
                                <option value="">همه</option>
                                <option value="ongoing">برگزار نشده ها</option>
                                <option value="done">برگزار شده ها</option>
                                
                                </select>
                            </a-col>



                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">عنوان</th>
                                        <th scope="col"> شهر</th>
                                        <th scope="col"> تاریخ </th>
                                        <th scope="col"> وضعیت </th>
                                        <th scope="col"> </th>
                                        <th scope="col"> </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>
                                            <b-avatar size="1.5rem"
                                                :src="row.image ? $root.image_concat(row.image) : ''">
                                            </b-avatar>

                                            <b-badge variant="light" class="text-dark">{{ row . title }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{ row . city . name }}</b-badge>
                                        </td>

                                        <td>
                                            {{ row . start_date != null ? new Date(row . start_date) . toLocaleDateString('fa-IR') : '-' }}
                                        </td>

                                      
                                        <td>
                                            <a-switch v-model="row.status" @change="changeStatus(row.id)" :disabled="!$root.hasPermission('/seminars/status/')" />
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <a-button class="btn-outline-warning" icon="edit" type="link" v-show="$root.hasPermission('/seminars/edit/')"
                                                :href="'/seminars/edit/' + row.id">ویرایش</a-button>
                                            &nbsp;
                                              <!-- <a-button
                        class="btn-outline-danger"
                        shape="square"
                        icon="delete"
                         v-show="$root.hasPermission('/seminars/delete/')"
                        @click="deleteRow(`seminars/delete/${row.id}`)"
                      ></a-button> -->
                                                                  &nbsp;

                                            <PlanModal :seminar="row" v-show="$root.hasPermission('/seminars/plans/')" />
                                            &nbsp;
                                            <ExecutiveModal :seminar="row" v-show="$root.hasPermission('/seminars/executive/')" />
                                            &nbsp;
                                               <a-button  icon="call" type="link"
                                :href="'/seminars/allGuests/' + row.id">لیست تماس</a-button>
                                 &nbsp;
                                             &nbsp;
                                            <a-button type="link" :href="'/seminars/sans/' + row.id" class="btn-outline-primary" v-show="$root.hasPermission('/seminars/sans/')">
                                                سانس ها
                                            </a-button>
                                            <a-button  icon="paper-clip" type="link"  v-show="$root.hasPermission('/seminars/survey/')"
                                                :href="'/seminars/survey/' + row.id">نظر سنجی</a-button>
                                           

                                            </div>
                                        <td>
                                            <div class="d-flex">
                                                <a-button class="btn-outline-warning" icon="line-chart" type="link"
                                                          v-show="$root.hasPermission('/seminars/reportDetail/')"
                                                          :href="`${$store.state.baseUrl}/seminars/${row.id}/info`">گزارش کلی سمینار</a-button>
                                                &nbsp;
                                            </div>

                                        </td>

                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import SansModal from '../../components/Seminars/ModalSans.vue';
    import PlanModal from '../../components/Seminars/ModalPlan.vue';
    import ExecutiveModal from '../../components/Seminars/ModalExecutive.vue';


    export default {
        components: {
            SansModal,
            PlanModal,
            ExecutiveModal
                    },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    title: "",
                    date: "",
                },
            };
        },
        methods: {
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url = `/seminars?page=${this.currentPage}&&title=${this.search.title}&&date=${this.search.date}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async changeStatus(id) {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/status/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("سمینار مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
             deleteRow(url) {
      this.$swal({
        title: " با حذف سطح دسترسی همه کاربران مربوط به آن حذف می شوند .  آیا از حذف اطلاعات اطمینان دارید؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "بله",
        denyButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          let _this = this;
          axios
            .get(url)
            .then(function (response) {
              _this.$toast.success("با موفقیت حذف شد.");
              _this.getData();
            })
            .catch(function (err) {
              _this.$root.handleAxiosError(err);
            });
        }
      });
    },
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
